import * as angular from "angular";
import {Attachment} from "../models/attachment.model";
import * as _ from "lodash";
import {AttachmentsService} from "./attachments-service.service";


export class AttachmentsDialog {

  /* @ngInject */
  constructor(private $mdDialog, private attachmentsService: AttachmentsService) {
  }

  imagesDialog(event, attachments?: Attachment[]) {
    const self = this;
    this.$mdDialog.show({
      template: require('./../views/tmpl/images-popup.tmpl.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $mdDialog) {
        $scope.attachments = [];

        $scope.cancel = () => {
          $mdDialog.cancel();
        };

        if (attachments.length) {
          const attachmentsWithTempUrl = [];

          _.forEach(attachments, (a: Attachment) => {
            const isTemporaryUrl = a.url?.includes("Expires");
            if (!isTemporaryUrl) {
              $scope.attachments.push(a)
            } else {
              attachmentsWithTempUrl.push(a);
            }
          })

          const blobNames = _.map(attachmentsWithTempUrl, (at: Attachment) => {
            return at.name;
          })

          if(blobNames.length){
            self.attachmentsService.getAttachmentsUrls(blobNames)
              .then((attachments: any) => {
                $scope.attachments = _.concat($scope.attachments, attachments);
              });
          }
        }
      }
    });

  }


}

angular
  .module('bringoz.admin.attachments')
  .service('attachmentsDialog', AttachmentsDialog);

